<template>
  <div class="container">
    <Header :theme="theme"></Header>
    <div class="fullPage" ref="fullPage">
      <div
        class="fullPageContainer"
        ref="fullPageContainer"
        @mousewheel="mouseWheelHandle" 
        @DOMMouseScroll="mouseWheelHandle"
      >
        <div :class="`section banner ${fullpage.current===1?'in':'out'}`" :style="`background-image: url(${bannerBack})`">
          <div class="content">
            <div class="text">
              <p class="name">关于我们</p>
              <p class="en">About Us</p>
            </div>
          </div>
        </div>
        <div :class="`section philosophy ${fullpage.current===2?'in':'out'}`" :style="`background-image: url(${philosophyBack})`">
          <el-image class="right" :src="philosophyBuilding"></el-image>
          <div class="content">
            <div class="left">
              <p class="en">Company Profile</p>
              <div class="divider"></div>
              <p class="cn">公司简介</p>
            </div>
            <div class="text">
              <el-image class="left-icon icon" :src="upIcon"></el-image>
              <el-image class="right-icon icon" :src="downIcon"></el-image>
              <p class="cn">南京浩伟智能科技有限公司</p>
              <p class="en">Nanjing Haowei Intelligent Technology Co., Ltd</p>
              <p class="des">成立于2013年，坐落于智能产业云集的南京市麒麟高新技术开发区，是一家专业从事计算机信息技术研发、生产、销售和服务的高科技企业。公司所有产品严格按照标准开发及生产，产品质量得到有效的保证。公司还拥有一支技术精良、训练有素的售后服务队伍及完善的售后服务体系。 </p>
            </div>
          </div>
        </div>
        <div :class="`section honor ${fullpage.current===3?'in':'out'}`" :style="`background-image: url(${detailBack})`">
          <div class="content">
            <div class="left">
              <p class="en">Honorary Qualifications</p>
              <div class="divider"></div>
              <p class="cn">荣誉资质</p>
            </div>
            <div class="text">
              <div class="list">
                <div class="item" v-for="(item,index) in honorList" :key="index">
                  <el-image class="cover" :src="item.cover" fit="scale-down" :preview-src-list="honorPreviewList"></el-image>
                  <p class="name">{{item.name}}</p>
                </div>
              </div>
              <el-pagination
                class="honor-page"
                @current-change="getHonorList"
                :hide-on-single-page="true"
                :current-page.sync="honorFilter.pageNum"
                :page-size="honorFilter.pageSize"
                background
                layout="prev, pager, next, jumper, total"
                :total="honorTotalCount">
              </el-pagination>
            </div>
          </div>
        </div>
        <div :class="`section partner ${fullpage.current===4?'in':'out'}`" :style="`background-image: url(${detailBack})`">
          <div class="content">
            <div class="left">
              <p class="en">Partners</p>
              <div class="divider"></div>
              <p class="cn">合作单位</p>
            </div>
            <div class="text">
              <div class="list">
                <div class="item" v-for="(item,index) in partnerList" :key="index">
                  <el-image class="logo" :src="item.cover" fit="fill"></el-image>
                </div>
              </div>
              <el-pagination
                class="partner-page"
                @current-change="getPartnerList"
                :hide-on-single-page="true"
                :current-page.sync="partnerFilter.pageNum"
                :page-size="partnerFilter.pageSize"
                background
                layout="prev, pager, next, jumper, total"
                :total="partnerTotalCount">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/layout/Header"
import { 
  api_getClientHonorList,
  api_getClientPartnerList,
} from "@/api/common"
export default {
  components:{
    Header,
  },
  data(){
    return{
      bannerBack:require("@/assets/img/about/banner.png"),
      philosophyBack:require("@/assets/img/index/philosophy.png"),
      philosophyBuilding:require("@/assets/img/index/philosophy-building.png"),
      detailBack:require("@/assets/img/back.png"),
      upIcon:require("@/assets/img/about/up.png"),
      downIcon:require("@/assets/img/about/down.png"),
      theme:"white",
      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0 // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
      },
      honorFilter:{
        pageNum:1,
        pageSize:10,
      },
      honorList:[],
      honorPreviewList:[],
      honorTotalCount:0,
      partnerFilter:{
        pageNum:1,
        pageSize:8,
      },
      partnerList:[],
      partnerTotalCount:0,
    }
  },
  created(){
    this.getHonorList()
    this.getPartnerList()
  },
  methods:{

    //获取荣誉列表
    getHonorList(){
      api_getClientHonorList(this.honorFilter)
        .then((res)=>{
          if(res && res.code===0){
            this.honorList=res.data.records
            this.honorTotalCount=res.data.total
            res.data.records.forEach(item=>{
              this.honorPreviewList.push(item.cover)
            })
          }
        })
    },

    //获取合作伙伴列表
    getPartnerList(){
      api_getClientPartnerList(this.partnerFilter)
        .then((res)=>{
          if(res && res.code===0){
            this.partnerList=res.data.records
            this.partnerTotalCount=res.data.total
          }
        })
    },

    next() { // 往下切换
      let len = 4; // 页面的个数
      if (this.fullpage.current + 1 <= len) { // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
      this.fullpage.current += 1; // 页面+1
      this.move(this.fullpage.current); // 执行切换
      }
    },
    pre() {// 往上切换
      if (this.fullpage.current - 1 > 0) { // 如果当前页面编号-1 大于0，则可以执行向下滑动
      this.fullpage.current -= 1;// 页面+1
      this.move(this.fullpage.current);// 执行切换
      }
    },
    move(index) {
      this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
      this.directToMove(index); //执行滚动
      if(index===3 || index===4){
        this.theme="black"
      }else{
        this.theme="white"
      }
      setTimeout(() => {  //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
      this.fullpage.isScrolling = false;
      }, 1010);
    },
    directToMove(index) {
      let height = this.$refs["fullPage"].clientHeight; //获取屏幕的宽度
      let scrollPage = this.$refs["fullPageContainer"]; // 获取执行tarnsform的元素
      let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
      scrollHeight= -(index - 1) * height + "px";
      scrollPage.style.transform = `translateY(${scrollHeight})`;
      this.fullpage.current = index;
    },
    mouseWheelHandle(event) { // 监听鼠标监听
      // 添加冒泡阻止
      let evt = event || window.event;
      if (evt.stopPropagation) {
      evt.stopPropagation();
      } else {
      evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) { // 判断是否可以滚动
      return false;
      }
      let e = event.originalEvent || event;
      this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
      if (this.fullpage.deltaY > 0) {
      this.next();
      } else if (this.fullpage.deltaY < 0) {
      this.pre();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
  width: 100%;
  animation-timing-function: ease;

  .fullPage{
    height: 100vh;
    overflow: hidden;

    .fullPageContainer{
      width: 100%;
      height: 100vh;
      transition: all linear 1s;

      .section{
        width: 100%;
        height: 100vh;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-size: cover;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        .content{
          width: 100rem;
          margin: 0 auto;
          color: #fff;
          height: 57.5rem;
          font-weight: 400;
          font-size: 1.125rem;
          line-height: 1.3125rem;
        }
      }

      .banner{
        .content{
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          

          .text{

            .name{
              font-size: 8.125rem;
              line-height: 9.75rem;
              letter-spacing: .625rem;
              font-weight:bold;
            }
            .en{
              font-size: 2.8125rem;
              line-height: 3.6875rem;
              font-weight: 400;
              margin-top: 1rem;
            }
          }
        }
      }
      .philosophy{
        position: relative;
        
        .right{
          position: absolute;
          width: 100%;
          height: 100vh;
          z-index: 2;
        }

        .content{
          z-index: 3;

          .left{
            margin-top: 12.5rem;

            .en{
              font-size: 1.875rem;
              line-height: 3.75rem;
              font-weight: bold;
              opacity: 0.5;
            }
            .divider{
              width: 3.75rem;
              height: .25rem;
              background-color: #fff;
            }
            .cn{
              margin-top: 1.25rem;
              font-size: 2rem;
              line-height: 2.5rem;
              font-weight: bold;
            }
          }
          .text{
            margin-top: 3.75rem;
            width: 47.625rem;
            height: 26.6875rem;
            background-color: rgba(0,60,150,0.78);;
            border-radius: 3.125rem 0 3.125rem 0;
            position: relative;
            padding: 5.125rem 7.8125rem;
            box-sizing: border-box;

            .icon{
              width: 3.0625rem;
              height: 2.125rem;
              position: absolute;
            }
            .left-icon{
              left: 3.0625rem;
              top: 2.5625rem;
            }
            .right-icon{
              right: 3.5rem;
              bottom: 3.0625rem;
            }
            .cn{
              font-size: 1.875rem;
              line-height: 1.875rem;
              font-weight: bold;
              letter-spacing: .125rem;
              color: #fff;
              margin-bottom: .75rem;
            }
            .en{
              font-size: 1rem;
              line-height: 1.875rem;
              font-weight: 400;
              color: rgba(255,255,255,0.3);
              margin-bottom: 1.625rem;
            }
            .des{
              font-size: 1.125rem;
              line-height: 1.875rem;
              font-weight: 400;
              color: #fff;
              text-indent: 2.25rem;
            }
          }
          
        }
      }
      .honor{
        position: relative;
        
        .content{
          margin: 25rem auto 0;
          color: #373737;

          .left{

            .en{
              font-size: 1.875rem;
              line-height: 3.75rem;
              font-weight: bold;
              opacity: 0.5;
            }
            .divider{
              width: 3.75rem;
              height: .25rem;
              background-color: #373737;
            }
            .cn{
              margin-top: 1.25rem;
              font-size: 2rem;
              line-height: 2.375rem;
              font-weight: bold;
            }
          }
          .text{
            color: #373737;
            margin-top: 2.5rem;
            white-space: nowrap;
            overflow: hidden;

            .list{
              width: 100%;
              display: grid;
              flex-wrap: wrap;
              justify-content: space-between;
              grid-template-columns: repeat(auto-fill, 15.625rem);
              grid-gap: 2.5rem;

              .item{
                width: 15.625rem;
                border-radius: .3125rem .3125rem .3125rem .3125rem;
                box-sizing: border-box;
                text-align: center;

                .cover{
                  height: 8.75rem;
                }
                .name{
                  width: 100%;
                  margin-top: .625rem;
                  font-size: 1.125rem;
                  line-height: 1.5625rem;
                  color: #373737;
                  font-weight: 700;
                  white-space:pre-wrap
                }
              }
            }
            .honor-page{
              position: absolute;
              bottom: 5rem;
              right: 10rem;
            }
          }
        }
      }
      .partner{
        position: relative;

        .content{
          margin: 25rem auto 0;
          color: #373737;

          .left{

            .en{
              font-size: 1.875rem;
              line-height: 3.75rem;
              font-weight: bold;
              opacity: 0.5;
            }
            .divider{
              width: 3.75rem;
              height: .25rem;
              background-color: #373737;
            }
            .cn{
              margin-top: 1.25rem;
              font-size: 2rem;
              line-height: 2.375rem;
              font-weight: bold;
            }
          }
          .text{
            color: #373737;
            margin-top: 2.5rem;
            white-space: nowrap;
            overflow: hidden;

            .list{
              width: 100%;
              display: grid;
              flex-wrap: wrap;
              justify-content: space-between;
              grid-template-columns: repeat(auto-fill, 20rem);
              grid-gap: 3.8125rem;

              .item{
                width: 20rem;
                height: 11.25rem;
                border-bottom: .375rem solid #124FB0;
                box-shadow: 0 .5rem .9375rem 0 rgba(0,0,0,0.08);
                border-radius: .3125rem .3125rem .3125rem .3125rem;
                box-sizing: border-box;
                background-color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;

                .logo{
                  width: 16rem;
                  height: 5.625rem;
                }

              }
            }
            .partner-page{
              position: absolute;
              bottom: 3.75rem;
              right: 10rem;
            }
          }
        }
      }
      .in{
        .text{
          animation: show 1s ease-out;
        }
        .left{
          animation: transIn 1s ease-out;
        }
        .right{
          animation: transRightIn 1s ease-out;
        }
      }
      .out{
        .text{
          animation: hidden 1s ease-out;
        }
        .left{
          animation: transOut 1s ease-out;
        }
        .right{
          animation: transRightOut 1s ease-out;
        }
      }
      @keyframes show {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
      @keyframes hidden {
        from {
          opacity: 1;
        }
        to {
          opacity: 0;
        }
      }
      @keyframes transIn {
        from {
          transform: translate(-25rem, 0);
        }
        to {
          transform: translate(0, 0);
        }
      }
      @keyframes transOut {
        from {
          transform: translate(0, 0);
        }
        to {
          transform: translate(-25rem, 0);
        }
      }
      @keyframes transRightIn {
        from {
          transform: translate(120rem, 0);
        }
        to {
          transform: translate(0, 0);
        }
      }
      @keyframes transRightOut {
        from {
          transform: translate(0, 0);
        }
        to {
          transform: translate(120rem, 0);
        }
      }
    }

  }
}
</style>
<style scoped>
.container /deep/ .el-pagination__jump{
  margin-right: 1.25rem;
}
</style>